'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
exports.default = {
  header: '',
  item: '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})',
  footer: '',
  seeAllOption: 'See all'
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/menu-select/defaultTemplates.js